var TabStyle;
(function (TabStyle) {
    TabStyle["ICON_AND_TEXT_INLINE"] = "icon-and-text-inline";
    TabStyle["ICON_AND_TEXT_STACKED"] = "icon-and-text-stacked";
    TabStyle["ICON_ONLY"] = "icon-only";
    TabStyle["TEXT_ONLY"] = "text-only";
})(TabStyle || (TabStyle = {}));
export { TabStyle, };
//# sourceMappingURL=tab-constants.js.map